// extracted by mini-css-extract-plugin
export var author = "index-module--author--wWW85";
export var companyNewsCard = "index-module--companyNewsCard--7ULkc";
export var left = "index-module--left--8ceOj";
export var right = "index-module--right--FXHe0";